import React, { useMemo, useState } from 'react';
import { Search } from 'lucide-react';
import { Input } from '../components/ui/input';
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from '../components/ui/accordion';
import Seo from '../components/Seo';
import { useI18n } from '../context/I18nContext';
import UI from '../lib/uiCatalog';

const FAQ_KEYS = [1, 2, 3, 4, 5, 6, 7, 8];

export default function FAQ() {
  const { t } = useI18n();
  const T = (k) => t(k, UI[k]);
  const [q, setQ] = useState('');

  const items = useMemo(
    () => FAQ_KEYS.map((n) => ({
      q: T(`faqitem.${n}.q`),
      a: T(`faqitem.${n}.a`),
    })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [t]
  );

  const filtered = items.filter((f) => f.q.toLowerCase().includes(q.toLowerCase()));

  return (
    <div>
      <Seo pageKey="faq" />
      <section className="hero-bg">
        <div className="container-x pt-16 pb-14 text-center max-w-3xl mx-auto">
          <span className="eyebrow">{T('faq.eyebrow')}</span>
          <h1 className="mt-4 text-4xl md:text-5xl font-bold text-[#0b1f3a] tracking-tight">{T('faq.title')}</h1>
          <p className="mt-4 text-slate-600">{T('faq.subtitle')}</p>
          <div className="mt-6 max-w-md mx-auto relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={16} />
            <Input
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder={T('faq.search_placeholder')}
              className="pl-9 bg-white h-11"
            />
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="container-x max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-3">
            {filtered.map((f, i) => (
              <AccordionItem
                key={i}
                value={'q' + i}
                className="border border-slate-200 rounded-xl px-5 bg-white"
              >
                <AccordionTrigger className="text-left text-[#0b1f3a] font-semibold hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 text-sm leading-relaxed">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
            {filtered.length === 0 && (
              <p className="text-center text-slate-500 py-10">{T('faq.empty')}</p>
            )}
          </Accordion>
        </div>
      </section>
    </div>
  );
}
